var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranArr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.305402 4.55592C-0.0133481 4.4278 -0.00959802 4.23717 0.326652 4.1253L12.2554 0.149046C12.586 0.0390462 12.7754 0.224046 12.6829 0.547796L9.27415 12.4765C9.1804 12.8072 8.97728 12.8222 8.82603 12.5203L5.97853 6.82467L0.305402 4.55592ZM3.36165 4.43092L6.88415 5.8403L8.78415 9.64155L11.0004 1.8853L3.36103 4.43092H3.36165Z",
    fill: "#173E6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranArr);
export default __webpack_public_path__ + "static/media/tranArr.18f03f1f6fc0b3bee142fcd16fecd671.svg";
export { ForwardRef as ReactComponent };